const messageModel = {
    messageName: 'messageModel',
    isShowMessageModel: false,
    messageModelTitle: 'success',
    messageModelMessage: '',
    yPosition: 0.35,
    titleColor: '#15223d',
    waitMillsSecondsToClose: 2500,
    reset: true,
    backToHome: false,
};

const main = {
    hide_for_login: false,
    messageModel,
};

export default main;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/store/main/state.ts